import { ReactElement } from 'react';

import { Scholarship } from '@backrs_ui/common-ui/src/models/scholarship';

import { Box } from '@mui/material';

import { AwardInfo } from './AwardInfo';
import { EligibilityRequirements } from './EligibilityRequirements';
import { HowToApply } from './HowToApply';
import { largeScholarshipContainerStyle } from './styles';

type NuggetScholarshipLargeProps = Readonly<{
  scholarshipInfo: Scholarship;
}>;

export function NuggetScholarshipLarge({
  scholarshipInfo,
}: NuggetScholarshipLargeProps): ReactElement {
  return (
    <Box sx={largeScholarshipContainerStyle}>
      <AwardInfo scholarshipInfo={scholarshipInfo} />

      <EligibilityRequirements scholarshipInfo={scholarshipInfo} />

      <HowToApply scholarshipInfo={scholarshipInfo} />
    </Box>
  );
}
